/* eslint-disable */
<template>
  <v-container fluid class="referee">
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="4" sm="4">
            <div><h3>Referees</h3></div>
          </v-col>
          <v-col cols="12" md="8" sm="8" class="text-right referee">
            <v-btn color="primary" link :to="{ name: 'RefereeCard' }">
              <v-icon class="mx-2"> add </v-icon>
              Add Referee
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card flat class="mt-4">
      <v-data-table
        id="scollStyle"
        ref="academic_list"
        :headers="headers"
        :items="referee"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        multi-sort
        class="elevation-0"
      >
        <!--BEGIN status-->
        <template v-slot:[`item.status`]="{ item }">
          <span class="table-exam text-lowercase"
            ><v-icon size="12" color="red">mdi-radiobox-marked</v-icon>
            {{ item["status"] }}</span
          >
        </template>
        <!--END status-->
        <!--BEGIN actions buttons-->
        <template v-slot:[`item.actions`]="{ item }">
          <v-menu open-on-hover>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="text-capitalize links"
                text
                v-bind="attrs"
                v-on="on"
                small
                ><v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                :to="{ name: 'RefereeCard', query: { edit: `${item.lineNo}` } }"
              >
                <v-icon color="blue darken-4">mode_edit</v-icon> Edit
              </v-list-item>
              <v-divider />
              <v-list-item @click="deleteReferee(item)">
                <v-icon color="red">delete</v-icon> Delete
              </v-list-item>
              <v-divider />
            </v-list>
          </v-menu>
        </template>
        <!--END actions buttons-->
      </v-data-table>
      <v-divider />
      <v-card-actions class="d-flex justify-space-between">
        <v-btn
          class="mx-2 contacts--button"
          color="error"
          text
          @click="$router.back()"
        >
          <v-icon class="mx-2"> arrow_back </v-icon>
          Back
        </v-btn>
        <!-- <v-btn
          class="mx-2 contacts--button"
          outlined
          color="primary"
          :to="{ name: 'Specialization' }"
        >
          Next
          <v-icon class="mx-2"> arrow_forward </v-icon>
        </v-btn> -->
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "RefereeComponent",
  beforeRouteEnter(to, from, next) {
    next(() => {
      window.document.title = "KISEB::Referees Profiles";
    });
  },
  data: () => ({
    sortBy: "lineNo",
    sortDesc: true,
  }),
  computed: {
    referee() {
      return this.$store.getters["Profile/refereeGetters"]("referees");
    },
    headers() {
      return [
        {
          text: "#S/N",
          align: "start",
          sortable: true,
          value: "lineNo",
        },
        { text: "Name", sortable: true, value: "name" },
        { text: "Designation", sortable: true, value: "designation" },
        { text: "Phone", sortable: true, value: "phoneNo" },
        { text: "Email Address", sortable: true, value: "eMail" },
        { text: "Address", sortable: true, value: "address" },
        { text: "Place Of Work", sortable: true, value: "placeOfWork" },
        // { text: "Status", sortable: true, value: "status" },
        { text: "Actions", sortable: false, value: "actions" },
      ];
    },
  },
  methods: {
    deleteReferee(data) {
      this.$store.dispatch("Profile/deletereferee", { ...data });
    },
  },
};
</script>

<style scoped>
@import url("referee.css");
</style>
